/** Doctor category pill — gold for A, slate for B, light grey for C. */
export default function CategoryBadge({ category, size = "md" }) {
  const styles = {
    A: "bg-callisto-gold/15 text-callisto-gold border-callisto-gold/40",
    B: "bg-slate-100 text-slate-700 border-slate-300",
    C: "bg-zinc-50 text-zinc-500 border-zinc-200",
  };
  const sizes = {
    sm: "text-[10px] px-1.5 py-0.5",
    md: "text-[11px] px-2 py-0.5",
    lg: "text-xs px-2.5 py-1",
  };
  const cls = styles[category] || styles.C;
  const sz = sizes[size] || sizes.md;
  return (
    <span
      data-testid={`category-badge-${category}`}
      className={`inline-flex items-center gap-1 ${sz} font-bold rounded-full border ${cls} uppercase tracking-wide whitespace-nowrap`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-60" />
      {category}
    </span>
  );
}
